import React from 'react';
import { useParallax } from '@hooks';

const AboutSection: React.FC = () => {
  const parallaxPosition = useParallax({ speed: 1 });
  const parallaxPosition2 = useParallax({ speed: 1.75 });

  return (
    <section className="section about text-center" aria-labelledby="about-label" id="about">
      <div className="container">
        <div className="about-content">
          <p className="label-2 section-subtitle" id="about-label">
            Our Story
          </p>

          <h2
            className="headline-1 section-title"
            id="authentic-northeastern-iron-pot-stews"
          >
            Authentic Northeastern Iron-Pot Stews
          </h2>

          <p className="section-text">
            Experience the rich tradition of northeastern Chinese cuisine with our signature
            iron-stew pot dishes. Each hearty stew is slow-cooked to perfection, combining fresh
            meats, vegetables, and aromatic spices in traditional iron pots that enhance the flavors
            and create unforgettable dining memories.
          </p>

          <div className="contact-label">Book Through Call</div>

          <a href="tel:+16263637268" className="body-1 contact-number hover-underline">
            +1 626-363-7268
          </a>

          <a href="#" className="btn btn-primary">
            <span className="text text-1">Read More</span>
            <span className="text text-2" aria-hidden="true">
              Read More
            </span>
          </a>
        </div>

        <figure className="about-banner">
          <img
            src="/assets/images/about-banner.jpg"
            width="570"
            height="570"
            loading="lazy"
            alt="about banner"
            className="w-100"
            data-parallax-item
            data-parallax-speed="1"
            style={{
              transform: `translate3d(${parallaxPosition.x}px, ${parallaxPosition.y}px, 0px)`,
            }}
          />

          <div
            className="abs-img abs-img-1 has-before"
            data-parallax-item
            data-parallax-speed="1.75"
            style={{
              transform: `translate3d(${parallaxPosition2.x}px, ${parallaxPosition2.y}px, 0px)`,
            }}
          >
            <img
              src="/assets/images/about-abs-image.jpg"
              width="285"
              height="285"
              loading="lazy"
              alt=""
              className="w-100"
            />
          </div>

          <div className="abs-img abs-img-2 has-before">
            <img
              src="/assets/images/badge-2.png"
              width="133"
              height="134"
              loading="lazy"
              alt=""
            />
          </div>
        </figure>

        <img
          src="/assets/images/shape-3.png"
          width="197"
          height="194"
          loading="lazy"
          alt=""
          className="shape"
        />
      </div>
    </section>
  );
};

export default AboutSection;
